import controller from './box-post-by-category.controller';
import templateDefault from './templates/box-post-t1-view.html';

let BoxPostByCategoryComponent = {
    template: templateDefault,
    controller,
    bindings: {
        shCtrl: '<',
        postByCategory: '<',

    }
};

changeTemplate.$inject = ['SessionService'];

function changeTemplate(SessionService) {
   return templateDefault;
}

export default BoxPostByCategoryComponent;



/** WEBPACK FOOTER **
 ** C:/Bitnami/wampstack-7.1.31-0/apache2/htdocs/toning/B2C/www/components/catalog/category/box-post-by-category/box-post-by-category.component.js
 **/